import DeviceTemplate from "../../models/DeviceTemplate";
import type TemplateGroup from "../../models/TemplateGroup";
import { EventKey } from "../../eventLogger/EventKeys";
import { itx } from "../../translationItx/itx";
import type { CatalogProductSelection } from "./CatalogProductSelection";

/** Reuse an existing product variant in this group, or import its decoded catalog metadata. */
export async function importCatalogProduct(parent: TemplateGroup, product: CatalogProductSelection): Promise<DeviceTemplate> {
  if (product.genericParams) return DeviceTemplate.createGeneric(parent, product.genericParams, product.orderNumber, product.genericProductType);
  const catalogId = product.catalogId || product.catalogItem?.CatalogId;
  if (!catalogId || !product.catalogItem) {
    throw new Error(itx("ServerTemplateList.importProductError", "An error occured while importing"));
  }
  const articleNo = product.variantArticleNumber || "";
  const existing = parent.templates.findFirst(template => template.knxProductData.modelDataId === catalogId
    && (template.orderInformation.articleNo || "") === articleNo);
  if (existing) return existing;
  const template = await DeviceTemplate.createFromServerData(parent, catalogId, product.catalogItem, articleNo || undefined);
  if (articleNo) template.orderInformation.articleNo = articleNo;
  if (!template.orderInformation.imageLink && product.imageUrl) template.orderInformation.imageLink = product.imageUrl;
  state.eventLogger.addEvent(EventKey.NewProductAddedToProject, { productId: catalogId, projectId: state.projectMetadata.id });
  return template;
}
